import Footer from 'components/Footer'
import Header from 'components/Header'
import * as React from 'react'
import { Button } from 'react-bootstrap'

const SceneComponent: React.FC = () => {
  return (
    <>
      <Header title="有効期限切れ" />
      <main>
        <section className="mx-4 my-5">
          <div className="mt-5">
            <p>パスワード再設定リンクの有効期限が切れています。</p>
            <p>再度、パスワード再設定の手続きを行ってください。</p>
          </div>
          <div className="mt-4">
            <Button variant="primary" className="w-100 py-4" href={'/login'}>
              ログイン画面へ戻る
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
